export default __webpack_public_path__ + "static/media/icon-dots.d904dfc3.svg";